import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import "./emailBuilderMobileDesignNudge.scss";

const EMAIL_BUILDER_MOBILE_NUDGE_STORAGE_KEY = "email-builder-mobile-design-nudge-dismissed";

function readEmailBuilderMobileNudgeDismissed(): boolean {
  try {
    return window.localStorage.getItem(EMAIL_BUILDER_MOBILE_NUDGE_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

interface IEmailBuilderMobileDesignNudgeProps {
  visible: boolean;
}

export function EmailBuilderMobileDesignNudge(props: IEmailBuilderMobileDesignNudgeProps) {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(() => readEmailBuilderMobileNudgeDismissed());

  useEffect(() => {
    if (!props.visible || dismissed) {
      document.documentElement.classList.remove("email-builder-shell--mobile-nudge-visible");
      return;
    }

    document.documentElement.classList.add("email-builder-shell--mobile-nudge-visible");
    return () => {
      document.documentElement.classList.remove("email-builder-shell--mobile-nudge-visible");
    };
  }, [dismissed, props.visible]);

  if (!props.visible || dismissed) {
    return null;
  }

  function handleDismiss() {
    setDismissed(true);
    try {
      window.localStorage.setItem(EMAIL_BUILDER_MOBILE_NUDGE_STORAGE_KEY, "1");
    } catch {
      // ignore storage failures
    }
  }

  return (
    <div className="email-builder-mobile-design-nudge" role="status" aria-live="polite">
      <p className="email-builder-mobile-design-nudge-message">
        {t("You're editing on mobile. For layout and column changes, we recommend desktop.")}
      </p>
      <button
        type="button"
        className="email-builder-mobile-design-nudge-dismiss"
        aria-label={t("Dismiss")}
        onClick={handleDismiss}
      >
        <FontAwesomeIcon icon={faXmark} aria-hidden="true" />
      </button>
    </div>
  );
}
